import {PageLink} from '../../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
export const FounderMarketBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Founder Market',
    path: '/founder-market',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const FounderMarketToolsBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const FounderMarketBreadCrumb = () => {
  const {formatMessage} = useIntl()

  const FounderMarketBreadCrumbs: Array<PageLink> = [
    {
      title: formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: formatMessage({id: 'Founder Market'}),
      path: '/founder-market',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  const FounderMarketToolsBreadCrumbs: Array<PageLink> = [
    {
      title: formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  return {
    FounderMarketBreadCrumbs,
    FounderMarketToolsBreadCrumbs,
  }
}
